<template>
    <div class="home">
        <h1>Classroom Support Plan Writer</h1>

        <!-- TODO: load blurb from config? -->
        <p>
            This free online tool contains
            <span class="strategy-count">{{ strategyCount }}</span>
            research-based intervention ideas to address common learning and behavior issues.
            Use it to create Classroom Support Plans for groups and individuals.
        </p>
        <b-row>
            <b-col class="text-center">
                <b-btn variant="primary"
                       @click="createDoc()">
                    Get Started
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import SupportPlan from "@/components/SupportPlan"

    export default {
        name: 'home',
        computed: {
            config() {
                return this.$store.state.config
            },
            strategyCount() {
                return this.config.supportPlan ? this.config.supportPlan.strategies.length : ''
            }
        },
        methods: {
            createDoc() {
                this.$api.createNewDoc(SupportPlan)
                    .then((doc) => {
                        // console.log(doc)
                        this.$router.replace(`/doc/id/${doc.key}`)
                    })
            }
        }
    }
</script>

<style lang="scss">

    @import 'sass/variables_mixins';

    .home {
        margin: 2em;
        background-color: #fff;
        padding: 2em;
        @include box-shadow(0 0 20px rgba(0, 0, 0, .15));
        max-width: 600px;

        h1 {
            text-align: center;
            font-size: 1.5rem;
        }

        p {
            font-size: 14px;
        }

        .strategy-count {
            font-size: 1.1em;
            font-weight: bold;
            padding: 2px 10px;
            border-radius: 5px;
            background-color: #FDF4E8;
        }

        @media(min-width: 500px) {
            h1 {
                margin-bottom: 1em;
            }
            p {
                margin-bottom: 1.5em;
            }
        }

        @media(min-width: 768px) {
            margin: 3em auto;
            padding: 3em;
            h1 {
                font-size: 2rem;
            }
            p {
                font-size: 16px;
            }
        }

        @media(min-width: 1024px) {
            margin: 4em auto;
        }
    }

</style>